export interface HttpErrorDetails {
  code?: string;
  detail?: string;
}

export class HttpError extends Error {
  public readonly status: number;
  public readonly code?: string;
  public readonly detail?: string;
  public readonly response: { status: number };

  constructor(status: number, message?: string, details?: HttpErrorDetails) {
    super(message || `HTTP error! status: ${status}`);
    this.name = 'HttpError';
    this.status = status;
    this.code = details?.code;
    this.detail = details?.detail;
    this.response = { status };
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}